import { useEffect, useState } from 'react';

const useMobileView = () => {
	const [isMobileView, setIsMobileView] = useState(false);
	const [isDisplaySideNav, setIsDisplaySideNav] = useState(false);
	const mobileViewWidth = 767;
	const showSideNavWidth = 993;

	const handleWindowResize = () => {
		setIsMobileView(window.innerWidth < mobileViewWidth ? true : false);
		setIsDisplaySideNav(window.innerWidth < showSideNavWidth ? true : false);
	};

	useEffect(() => {
		handleWindowResize();
		window.addEventListener('resize', handleWindowResize);

		return () => {
			window.removeEventListener('resize', handleWindowResize);
		};
	}, []);

	return [isMobileView, isDisplaySideNav];
};

export default useMobileView;
